var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRoundedCorner = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 69 69",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 68.926h9.856l.017-.017V25.623c0-8.698 7.069-15.767 15.767-15.767h43.286V0H25.64C11.502 0 0 11.502 0 25.64v43.286Z",
  fill: "url(#rounded-corner_svg__a)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "rounded-corner_svg__a",
  x1: 68.926,
  y1: 68.926,
  x2: -0.558,
  y2: 68.294,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.15,
  stopColor: "#D91241"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#0D0B4D"
})))));
export default SvgRoundedCorner;